export { default } from './es/icons/RotateLeftOutlined';